var map = {
	"./2023-09-19-SDO-Sun.png": 4974,
	"./A.png": 875,
	"./AnnularEclipseMap.png": 5422,
	"./B.png": 8896,
	"./C.png": 3721,
	"./eclipse.gif": 9442,
	"./eclipse_static.gif": 435,
	"./giphy.webp": 6256,
	"./moon-dark-gray-overlay.png": 959,
	"./moon-sky-blue-overlay.png": 6405,
	"./moon.png": 2783,
	"./video.mp4": 9007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;